import { Check, ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

interface LevelItemProps {
  level: {
    id: number;
    name: string;
    points: number;
    icon: JSX.Element;
    completed: boolean;
    current: boolean;
    benefits: string[];
    requirement: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}

export const LevelItem = ({ level, isOpen, onToggle }: LevelItemProps) => {
  return (
    <Collapsible
      open={isOpen}
      onOpenChange={onToggle}
      className={`bg-primary/20 dark:bg-gray-800/50 rounded-lg p-4 backdrop-blur-sm border-2 transition-colors ${
        level.current 
          ? 'border-clubbers-blue dark:border-clubbers-blue sunset:border-sunset forest:border-forest ocean:border-ocean' 
          : level.completed 
            ? 'border-green-500/50' 
            : 'border-transparent'
      }`}
    >
      <CollapsibleTrigger className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4">
          {level.icon}
          <div className="text-left">
            <h3 className="font-semibold">{level.name}</h3>
            <p className="text-sm text-foreground">
              {level.completed 
                ? "¡Completado!" 
                : `${level.points} logros requeridos`}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {level.completed && (
            <span className="text-green-500">
              <Check className="w-5 h-5" />
            </span>
          )}
          <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`} />
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-4 space-y-4">
        <div className="space-y-2">
          <h4 className="font-medium text-primary">¿Cómo alcanzar este nivel?</h4>
          <p className="text-sm text-foreground dark:text-gray-300">{level.requirement}</p>
        </div>
        <div className="space-y-2">
          <h4 className="font-medium text-primary">Beneficios:</h4>
          <ul className="list-disc list-inside space-y-1 text-sm">
            {level.benefits.map((benefit, i) => (
              <li className="text-foreground" key={i}>{benefit}</li>
            ))}
          </ul>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};